var de = Object.defineProperty, fe = Object.defineProperties;
var ve = Object.getOwnPropertyDescriptors;
var J = Object.getOwnPropertySymbols;
var ye = Object.prototype.hasOwnProperty, ge = Object.prototype.propertyIsEnumerable;
var W = (c, u, r) => u in c ? de(c, u, { enumerable: !0, configurable: !0, writable: !0, value: r }) : c[u] = r, L = (c, u) => {
  for (var r in u || (u = {}))
    ye.call(u, r) && W(c, r, u[r]);
  if (J)
    for (var r of J(u))
      ge.call(u, r) && W(c, r, u[r]);
  return c;
}, H = (c, u) => fe(c, ve(u));
var D = (c, u, r) => new Promise((M, h) => {
  var N = (d) => {
    try {
      v(r.next(d));
    } catch (g) {
      h(g);
    }
  }, S = (d) => {
    try {
      v(r.throw(d));
    } catch (g) {
      h(g);
    }
  }, v = (d) => d.done ? M(d.value) : Promise.resolve(d.value).then(N, S);
  v((r = r.apply(c, u)).next());
});
import "../../../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import we from "./components/index.vue.js";
import { getShowerRoomModels as he, getshowerRoomModelOption as be, reqConvertMscsContent as Ce } from "../../../../request/template/post.js";
import je from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/auto-complete/src/AutoComplete.js";
import { withKeys as ke } from "../../../../node_modules/.pnpm/@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import { defineComponent as Ne, useTemplateRef as Se, computed as _e, watch as Q, openBlock as C, createElementBlock as E, createElementVNode as X, createVNode as p, withCtx as i, createBlock as x, createCommentVNode as T, createTextVNode as G, Fragment as Y, renderList as xe } from "../../../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as f, reactive as Z, unref as s } from "../../../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { useMessage as Te } from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import Me from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/card/src/Card.js";
import Pe from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
import Ie from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/Form.js";
import B from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/legacy-grid/src/Row.js";
import V from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/legacy-grid/src/Col.js";
import O from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/FormItem.js";
import ee from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/select/src/Select.js";
import R from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
import { toDisplayString as ze, normalizeClass as Le } from "../../../../node_modules/.pnpm/@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
import De from "../../../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
const Ee = {
  key: 0,
  class: "tw:!flex tw:justify-center tw:gap-4 tw:mt-6"
}, tt = /* @__PURE__ */ Ne({
  __name: "index",
  props: {
    orderParam: { default: () => ({}) },
    options: {},
    params: {},
    openType: {},
    sys: {}
  },
  emits: ["hide-dialog", "onSuccess", "cancel"],
  setup(c, { expose: u, emit: r }) {
    const M = Se("GroundMass"), h = c, N = r, S = f(!0), v = f(!1), d = f([]), g = f([]), _ = f(!1), P = f(null), b = f("");
    f("");
    const j = f(null), te = f(""), ae = f(!1), o = Z({
      name: "",
      mujia: "",
      type: ""
    }), k = Z({
      mujia: [],
      type: []
    }), w = f([]), oe = _e(() => d.value.filter(
      (t) => t.name.toLowerCase().includes(o.name.toLowerCase())
    )), U = Te(), le = () => {
      var t;
      te.value = ((t = h.orderParam) == null ? void 0 : t.productionId) || "", he({ searchKeyWord: "" }).then((a) => {
        var n, l;
        console.log("获取产品编码下拉值res", a), d.value = [], a.data.length && a.data.forEach((m) => {
          d.value.push(L({ value: m.name }, m));
        }), ((n = h.options) == null ? void 0 : n.content) || "" ? (w.value = [], j.value = h.options.content, o.name = j.value.name, b.value = j.value.name, F(b.value), o.mujia = j.value.mujia) : (o.name = ((l = h.options) == null ? void 0 : l.productModel) || "", K());
      }).catch((a) => {
        console.log("获取产品编码下拉值error", a);
      });
    }, ne = (t) => {
      console.log("选中的项目:", t);
    }, F = (t) => {
      var a;
      v.value = !0, be({
        modelName: t,
        channel: (a = h.orderParam) == null ? void 0 : a.checkProductChannel
      }).then((e) => {
        var n, l, m, y, I;
        v.value = !1, P.value = e.data, e.data.name && (o.name = e.data.name, b.value = e.data.name), k.mujia = ((m = (l = (n = e.data.mujiaGroup) == null ? void 0 : n.gategories) == null ? void 0 : l[0]) == null ? void 0 : m.options) || [], k.type = [], (I = (y = e.data.stoneGroup) == null ? void 0 : y.gategories) == null || I.forEach((z) => {
          k.type.push({ name: z.name, optionId: z.name });
        }), j.value && j.value.productList.forEach((z) => {
          var $, q;
          (q = ($ = e.data.stoneGroup) == null ? void 0 : $.gategories) == null || q.forEach((A) => {
            A.name === z.name && w.value.push(A);
          });
        });
      }).catch((e) => {
        v.value = !1, console.log("获取报文接口error", e);
      });
    }, K = () => {
      o.mujia = "", o.type = "", k.mujia = [], k.type = [], w.value = [], b.value = o.name, b.value && F(b.value);
    }, se = () => {
      var t, a, e;
      if (!o.type) {
        U.warning("您未选择石基类型！");
        return;
      }
      if (w.value.length >= 20) {
        U.warning("最多仅可添加20条！");
        return;
      }
      (e = (a = (t = P.value) == null ? void 0 : t.stoneGroup) == null ? void 0 : a.gategories) == null || e.forEach((n) => {
        n.name === o.type && w.value.push(n);
      });
    }, re = (t) => {
      const a = Object.entries(t).reduce((e, [n, l]) => (e[n] = String(l), e), {});
      g.value.push(a);
    }, ue = (t) => {
      w.value.splice(t, 1);
    }, ie = () => D(this, null, function* () {
      var n, l, m;
      let t = d.value.find((y) => y.name === o.name);
      const a = {
        name: b.value,
        mujia: o.mujia,
        modelId: (n = t == null ? void 0 : t.modelId) != null ? n : "",
        description: (l = t == null ? void 0 : t.description) != null ? l : "",
        series: (m = t == null ? void 0 : t.series) != null ? m : "",
        productList: g.value
      }, e = {
        content: a,
        mscsContent: a
      };
      v.value = !0;
      try {
        const y = yield Ce(H(L({}, e), { type: 1 }));
        e.mscsContent = y, N("onSuccess", e);
      } catch (y) {
        console.error("转换内容失败:", y);
      } finally {
        v.value = !1;
      }
    }), pe = () => D(this, null, function* () {
      ae.value = !1, _.value = !0, yield ie(), setTimeout(() => {
        _.value = !1, g.value = [];
      }, 300);
    }), me = () => {
      _.value = !1, g.value = [], N("hide-dialog");
    }, ce = () => {
      N("hide-dialog");
    };
    return Q(g, (t) => {
      var a, e, n;
      if (t.length === w.value.length) {
        _.value = !1;
        let l = d.value.find((I) => I.name === o.name);
        const m = {
          name: b.value,
          mujia: o.mujia,
          modelId: (a = l == null ? void 0 : l.modelId) != null ? a : "",
          description: (e = l == null ? void 0 : l.description) != null ? e : "",
          series: (n = l == null ? void 0 : l.series) != null ? n : "",
          productList: g.value
        }, y = {
          content: m,
          mscsContent: m
        };
        console.log("产品参数:", y), N("onSuccess", y);
      }
    }), Q(
      S,
      (t) => {
        t && (o.name = "", o.mujia = "", o.type = "", le());
      },
      { immediate: !0 }
    ), u({
      isShowDialog: S
    }), (t, a) => (C(), E(Y, null, [
      X("div", {
        ref_key: "GroundMass",
        ref: M
      }, null, 512),
      p(s(De), {
        bordered: "",
        show: S.value,
        "onUpdate:show": a[3] || (a[3] = (e) => S.value = e),
        "mask-closable": !1,
        to: M.value || "body"
      }, {
        default: i(() => [
          p(s(Me), {
            class: "tw:!w-[1200px] tw:!box-border tw:!text-left",
            title: "石基",
            bordered: !1,
            role: "dialog",
            "header-class": "tw:!text-center",
            closable: "",
            onClose: ce
          }, {
            default: i(() => [
              p(s(Pe), { show: v.value }, {
                default: i(() => [
                  X("div", {
                    class: Le(["ground-mass", { "n-loading": v.value }])
                  }, [
                    p(s(Ie), {
                      style: { display: "flex", "flex-direction": "column" },
                      inline: "",
                      "label-placement": "left",
                      class: "tw:!text-left",
                      size: "small",
                      "require-mark-placement": "right-hanging",
                      "label-width": "120px"
                    }, {
                      default: i(() => [
                        p(s(B), { class: "bottom-line" }, {
                          default: i(() => [
                            p(s(V), { span: 16 }, {
                              default: i(() => [
                                p(s(O), {
                                  label: "添加石基型号",
                                  size: "small"
                                }, {
                                  default: i(() => [
                                    p(s(je), {
                                      disabled: !0,
                                      value: o.name,
                                      "onUpdate:value": a[0] || (a[0] = (e) => o.name = e),
                                      options: oe.value,
                                      placeholder: "请输入石基型号",
                                      onKeyup: ke(K, ["enter"]),
                                      onSelect: ne,
                                      class: "tw:!w-[300px]"
                                    }, null, 8, ["value", "options"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        P.value ? (C(), x(s(B), {
                          key: 0,
                          class: "bottom-line"
                        }, {
                          default: i(() => [
                            p(s(V), { span: 16 }, {
                              default: i(() => [
                                p(s(O), {
                                  label: "木架包装",
                                  size: "small"
                                }, {
                                  default: i(() => [
                                    p(s(ee), {
                                      value: o.mujia,
                                      "onUpdate:value": a[1] || (a[1] = (e) => o.mujia = e),
                                      placeholder: "请选择",
                                      disabled: t.openType === "view",
                                      options: k.mujia.map((e) => ({ label: e.name, value: e.name })),
                                      class: "tw:!w-[300px]"
                                    }, null, 8, ["value", "disabled", "options"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })) : T("", !0),
                        P.value && t.openType !== "view" ? (C(), x(s(B), {
                          key: 1,
                          class: "bottom-line"
                        }, {
                          default: i(() => [
                            p(s(V), { span: 16 }, {
                              default: i(() => [
                                p(s(O), {
                                  label: "石基类型",
                                  size: "small"
                                }, {
                                  default: i(() => [
                                    p(s(ee), {
                                      value: o.type,
                                      "onUpdate:value": a[2] || (a[2] = (e) => o.type = e),
                                      placeholder: "请选择",
                                      options: k.type.map((e) => ({ label: e.name, value: e.optionId })),
                                      class: "tw:!w-[300px]"
                                    }, null, 8, ["value", "options"]),
                                    p(s(R), {
                                      style: { "margin-left": "20px" },
                                      type: "primary",
                                      size: "small",
                                      onClick: se
                                    }, {
                                      default: i(() => a[4] || (a[4] = [
                                        G(" 添加 ", -1)
                                      ])),
                                      _: 1,
                                      __: [4]
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })) : T("", !0),
                        (C(!0), E(Y, null, xe(w.value, (e, n) => {
                          var l, m;
                          return C(), x(we, {
                            key: `${e.name}-${n}`,
                            productCell: e,
                            index: n,
                            callbackProduct: _.value,
                            openType: t.openType,
                            content: ((m = (l = j.value) == null ? void 0 : l.productList) == null ? void 0 : m[n]) || {},
                            onSubmitProduct: re,
                            onDeleteCell: ue
                          }, null, 8, ["productCell", "index", "callbackProduct", "openType", "content"]);
                        }), 128))
                      ]),
                      _: 1
                    }),
                    w.value.length ? (C(), E("div", Ee, [
                      t.openType !== "view" ? (C(), x(s(R), {
                        key: 0,
                        type: "primary",
                        size: "small",
                        onClick: pe
                      }, {
                        default: i(() => a[5] || (a[5] = [
                          G(" 保存 ", -1)
                        ])),
                        _: 1,
                        __: [5]
                      })) : T("", !0),
                      t.openType !== "view" ? (C(), x(s(R), {
                        key: 1,
                        type: "primary",
                        size: "small",
                        onClick: me
                      }, {
                        default: i(() => [
                          G(ze(t.sys === "mtds2" ? "关闭" : "保存并关闭"), 1)
                        ]),
                        _: 1
                      })) : T("", !0)
                    ])) : T("", !0)
                  ], 2)
                ]),
                _: 1
              }, 8, ["show"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["show", "to"])
    ], 64));
  }
});
export {
  tt as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/GroundMass/index.vue2.js
// module id = 1194
// module chunks = 41